import { EdgeUpdateSchedule } from '@/react/portainer/environments/update-schedules/types';
import { useRemoveMutation } from '@/react/portainer/environments/update-schedules/queries/useRemoveMutation';
import { notifySuccess } from '@/portainer/services/notifications';

import { DeleteButton } from '@@/buttons/DeleteButton';
import { AddButton } from '@@/buttons';

export function TableActions({
  selectedRows,
  batchDelete,
}: {
  selectedRows: EdgeUpdateSchedule[];
  batchDelete: boolean;
}) {
  const removeMutation = useRemoveMutation();

  return (
    <div className="flex items-center gap-2">
      {batchDelete && (
        <DeleteButton
          onConfirmed={() => handleRemove()}
          disabled={selectedRows.length === 0}
          data-cy="remove-update-schedules-button"
          confirmMessage="Are you sure you want to remove these schedules?"
        />
      )}

      <AddButton data-cy="add-update-schedules-button">
        Schedule update or rollback
      </AddButton>
    </div>
  );

  async function handleRemove() {
    removeMutation.mutate(selectedRows, {
      onSuccess: () => {
        notifySuccess('Success', 'Schedules successfully removed');
      },
    });
  }
}
